import React from "react";
import { Button } from "primereact/button";

const CarrierTabs = ({ groups = [], activeCarrier, onSelect }) => (
  <div className="p-d-flex p-flex-wrap" style={{ gap: "0.5rem" }}>
    {groups.map((group) => (
      <Button
        key={group.key}
        label={group.label}
        className={group.key === activeCarrier ? "p-button-sm" : "p-button-sm p-button-outlined"}
        onClick={() => onSelect(group.key)}
      />
    ))}
  </div>
);

export default CarrierTabs;
